import React, { useEffect, useMemo, useState } from 'react';
import locationIcon from '../../assets/icons/ic_location.svg'
import IconTint from 'react-icon-tint';
import Dropdown from '../Dropdown';
import LocationSelectionGrid from '../LocationSelectionGrid';
import { savedSelectedLoc } from '../store/DataStore';
import { useSetAtom } from 'jotai';
import ModalShell from './ModalShell';
import { getVisibleLocationOrDefault, getVisibleLocations } from './locationVisibility';

const LOCATION_GRID_THRESHOLD = 30;

const ComeHerePopup = ({ isOpen, children, onClose, onSend, locations, currentLocation }) => {
    const [show, setShow] = useState(isOpen);
    const [selectedToSaved, setSelectedToSaved] = useState('');
    const setSelectedGoto = useSetAtom(savedSelectedLoc)
    const [isDropdownTouched, setIsDropdownTouched] = useState(false)
    const visibleLocations = useMemo(() => getVisibleLocations(locations), [locations]);
    const canSend = visibleLocations.includes(selectedToSaved);

    useEffect(() => {
        if (isOpen) {
            setShow(true);
            if(!isDropdownTouched){
                const defaultDestination = getVisibleLocationOrDefault(currentLocation, visibleLocations);
                setSelectedToSaved(defaultDestination);
                setSelectedGoto(defaultDestination);
            }
        } else {
            setShow(false);
            setTimeout(onClose, 200);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen, onClose, currentLocation, isDropdownTouched, setSelectedGoto, visibleLocations]);

    const defaultLocation = visibleLocations[0] || '';

    const handleClose = () => {
        setShow(false);
        setTimeout(onClose, 200);
        setSelectedToSaved(defaultLocation);
        setIsDropdownTouched(false);
    };

    const handleSend = () => {
        onSend();
        setShow(false);
        setTimeout(onClose, 200);
        setSelectedToSaved(defaultLocation);
        setIsDropdownTouched(false);
    }

    const setSelectedTo = (item) => {
        setIsDropdownTouched(true);
        setSelectedToSaved(item);
        setSelectedGoto(item);
        console.log("selected to " + item)
    }

    const useLocationGrid = visibleLocations.length < LOCATION_GRID_THRESHOLD;

    return (
        <ModalShell isMounted={show || isOpen} isOpen={show} onClose={handleClose} maxWidth="md">
            <div className="-mt-2 flex flex-col items-center text-center">
                {children}
            </div>
            <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2">
                <label className="block">
                    <span className="font-heebo text-md font-light">Current Location</span>
                    <span className="mt-1 block min-h-[44px] w-full rounded-md bg-[#3C5BD2] bg-opacity-5 px-3 py-2 font-heebo font-light text-[#476bfb]">
                        {currentLocation !== '' ? currentLocation : 'Movement needed'}
                    </span>
                </label>
                <label className="block">
                    <span className="font-heebo text-md font-light">Destination</span>
                    {useLocationGrid ? (
                        <LocationSelectionGrid
                            locations={visibleLocations}
                            selectedLocation={selectedToSaved}
                            onSelect={setSelectedTo}
                            columnsClass="grid-cols-1 md:grid-cols-2"
                            buttonClassName="w-full min-w-0"
                            emptyMessage="No destinations available"
                        />
                    ) : (
                        <Dropdown
                            list={visibleLocations}
                            setSelected={(item) => setSelectedTo(item)}
                            selectedItem={selectedToSaved}
                            fullWidth={true}
                        />
                    )}
                </label>
            </div>
            <div className="mt-8 flex justify-center">
                {canSend ? (
                    <button
                        type="button"
                        className="flex w-full items-center justify-center rounded-3xl bg-[#152FF5] px-5 py-2 text-white sm:w-auto"
                        onClick={handleSend}
                    >
                        <span className="font-heebo">Confirm</span>
                        <IconTint src={locationIcon} className="ml-2 h-5" color="#FFFFFF" />
                    </button>
                ) : (
                    <div className="flex w-full items-center justify-center rounded-3xl bg-[#152FF5] px-5 py-2 opacity-50 sm:w-auto">
                        <span className="font-heebo text-white">Confirm</span>
                        <IconTint src={locationIcon} className="ml-2 h-5" color="#FFFFFF" />
                    </div>
                )}
            </div>
        </ModalShell>
    );
};

export default ComeHerePopup;
